export enum EnumTipoDownload {
    CSV = 1,
    TXT = 2,
    XLSX = 3,
  }